import React, { useState } from 'react';
import { Trophy, Users, Plus, UserCog, Trash2, Download, Upload, Calendar, Clock, MapPin } from 'lucide-react';
import CreateTournamentModal from './CreateTournamentModal';
import './TournamentList.css';

export default function TournamentList({ tournaments, onCreate, onSelect, onDelete, role, onShowRanking, onShowPlayers, onImport }) {
    const [showCreateModal, setShowCreateModal] = useState(false);

    const exportTournament = (e, tournament) => {
        e.stopPropagation();
        const dataToExport = { ...tournament };
        const dataStr = JSON.stringify(dataToExport, null, 2);
        const blob = new Blob([dataStr], { type: "application/json" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        const safeName = tournament.name.replace(/[^a-z0-9]/gi, '_').toLowerCase();
        a.download = `backup_torneo_${safeName}.json`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };

    return (
        <div className="tournament-list-container animate-fade-in">
            <div className="tournament-list-header">
                <h2 className="tournament-list-title">
                    <Trophy /> Torneos
                </h2>
                <div className="tournament-actions-group">
                    {role === 'admin' && (
                        <button onClick={onShowPlayers} className="btn btn-secondary">
                            <UserCog className="w-5 h-5"/> Jugadores
                        </button>
                    )}
                    <button onClick={onShowRanking} className="btn btn-warning">
                        <Trophy className="w-5 h-5"/> Ranking Liga
                    </button>
                    {role === 'admin' && (
                        <>
                            <input type="file" id="import-tournament-file" style={{display: 'none'}} accept=".json" onChange={onImport} />
                            <button onClick={() => document.getElementById('import-tournament-file').click()} className="btn btn-secondary" title="Importar copia de seguridad local">
                                <Upload className="w-5 h-5"/> Importar
                            </button>
                            <button onClick={() => setShowCreateModal(true)} className="btn btn-danger">
                                <Plus className="w-5 h-5"/> Nuevo
                            </button>
                        </>
                    )}
                </div>
            </div>

            {tournaments.length === 0 && (
                <div className="empty-state">
                    No hay batallas programadas
                </div>
            )}

            <div className="grid-cards">
                {tournaments.map(t => (
                    <div key={t.id} className={`glass-panel tournament-card ${t.isUnranked ? 'unranked' : ''}`}>
                        {/* Image Header */}
                        {t.imageUrl && (
                            <div className="card-image-header">
                                <img src={t.imageUrl} alt={t.name} className="card-image" onError={(e) => { e.target.onerror = null; e.target.style.display = 'none'; }} />
                                <div className="card-image-overlay"></div>
                                {t.isUnranked && (
                                    <div className="badge-unranked">
                                        NO RANKEADO
                                    </div>
                                )}
                            </div>
                        )}

                        <div className="card-content">
                            {!t.imageUrl && t.isUnranked && (
                                <div className="badge-unranked">
                                    NO RANKEADO
                                </div>
                            )}
                            <div style={{display: 'flex', flexDirection: 'column', gap: '1rem'}}>
                                <h3 className="card-title" title={t.name}>{t.name}</h3>
                                
                                <div className="card-tags">
                                    <span className={`tag-phase ${t.phase === 'completed' ? 'completed' : ''}`}>
                                        {t.phase === 'setup' ? 'Registro' : t.phase === 'phase1' ? 'Suizo' : t.phase === 'phase_tiebreaker' ? 'Desempate' : t.phase === 'phase2' ? 'Finales' : 'Completado'}
                                    </span>
                                    {t.isUnranked && (
                                        <span className="tag-phase">
                                            Amistoso
                                        </span>
                                    )}
                                    <span className="tag-phase" style={{display: 'flex', alignItems: 'center', gap: '0.25rem'}}><Users className="w-3 h-3"/> {t.players?.length || 0}</span>
                                </div>

                                {/* Detalles Nuevos */}
                                {(t.date || t.time || t.locationUrl) && (
                                    <div className="card-details">
                                        {t.date && <span className="detail-item"><Calendar className="w-4 h-4" /> {t.date}</span>}
                                        {t.time && <span className="detail-item"><Clock className="w-4 h-4" /> {t.time}</span>}
                                        {t.locationUrl && (
                                            <a href={t.locationUrl} target="_blank" rel="noreferrer" className="detail-item detail-link" onClick={e => e.stopPropagation()}>
                                                <MapPin className="w-4 h-4" style={{color:'var(--accent-red)'}} /> Mapa
                                            </a>
                                        )}
                                    </div>
                                )}

                                {t.description && (
                                    <div className="card-description">
                                        "{t.description}"
                                    </div>
                                )}
                            </div>

                            <div className="card-actions">
                                <button onClick={() => onSelect(t.id)} className="btn-enter-stadium">
                                    {role === 'admin' ? 'Entrar al Estadio' : 'Ver Estadio'}
                                </button>
                                {role === 'admin' && t.phase === 'completed' && (
                                    <button onClick={(e) => exportTournament(e, t)} className="btn-icon-only" title="Descargar Copia de Seguridad">
                                        <Download className="w-5 h-5" />
                                    </button>
                                )}
                            </div>
                        </div>

                        {role === 'admin' && (
                            <button onClick={(e) => { e.stopPropagation(); onDelete(t.id); }} className={`btn-delete ${t.imageUrl ? 'with-image' : 'without-image'}`}>
                                <Trash2 className="w-6 h-6" />
                            </button>
                        )}
                    </div>
                ))}
            </div>

            {showCreateModal && (
                <CreateTournamentModal 
                    onClose={() => setShowCreateModal(false)}
                    onCreate={(data) => {
                        setShowCreateModal(false);
                        onCreate(data);
                    }}
                />
            )}
        </div>
    );
}